import { CUSTOM_FILTERS } from "@/config/list";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { ListFilters } from "@/types/list";

type HasDataFilterProps = {
	filter: ListFilters;
};

type OptionValue = "all" | "withData" | "notConfigured";

const OPTIONS: { label: string; value: OptionValue }[] = [
	{ label: "All", value: "all" },
	{ label: "With data", value: "withData" },
	{ label: "Not configured", value: "notConfigured" },
];

export const HasDataFilter = ({ filter }: HasDataFilterProps) => {
	const hasData = filter.getFilter(CUSTOM_FILTERS.hasData) as boolean | undefined;
	const isFullyConfiguredForIAndI = filter.getFilter(CUSTOM_FILTERS.isFullyConfiguredForIAndI) as boolean | undefined;

	const value: OptionValue =
		hasData === true ? "withData" : isFullyConfiguredForIAndI === false ? "notConfigured" : "all";

	// "With data" (has a calculated summary) and "Not configured" (missing required properties) are
	// two different signals, so selecting one clears the other.
	const onChange = (selected: OptionValue) => {
		if (selected === "withData") {
			filter.setFilter(CUSTOM_FILTERS.hasData, true);
			filter.clearFilter(CUSTOM_FILTERS.isFullyConfiguredForIAndI);
		} else if (selected === "notConfigured") {
			filter.setFilter(CUSTOM_FILTERS.isFullyConfiguredForIAndI, false);
			filter.clearFilter(CUSTOM_FILTERS.hasData);
		} else {
			filter.clearFilter(CUSTOM_FILTERS.hasData);
			filter.clearFilter(CUSTOM_FILTERS.isFullyConfiguredForIAndI);
		}
	};

	const activeLabel = OPTIONS.find(option => option.value === value)?.label ?? "All";

	return (
		<div className="relative z-10">
			<div className="flex flex-col space-y-1">
				<span className="text-xs font-medium text-muted-foreground">Status</span>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="outline" className="justify-start">
							<span className={value === "all" ? "font-semibold text-muted-foreground" : "font-semibold"}>
								{activeLabel}
							</span>
							<ChevronDown className="ml-2 h-4 w-4 opacity-50" />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align="start">
						{OPTIONS.map(option => (
							<DropdownMenuItem
								key={option.label}
								onSelect={() => onChange(option.value)}
								className={option.value === value ? "font-semibold bg-muted" : ""}
							>
								{option.label}
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</div>
	);
};
